import { render, staticRenderFns } from "./InventoryManagement.vue?vue&type=template&id=47c654ec&scoped=true&"
import script from "./InventoryManagement.vue?vue&type=script&lang=js&"
export * from "./InventoryManagement.vue?vue&type=script&lang=js&"
import style0 from "./InventoryManagement.vue?vue&type=style&index=0&id=47c654ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c654ec",
  null
  
)

export default component.exports